<template>
  <div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <span>计算的结果为：{{ values }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <div class="el-back-tree">
      <el-tree v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)" ref="tree" :data="tree_data" :props="props"
        :expand-on-click-node="false" :auto-expand-parent="true" :highlight-current="true" :indent="12" node-key="id"
        @current-change="tree_selection_change" @node-contextmenu="tree_right_click" @node-click="tree_left_click"
        draggable :allow-drag="allowDrag" :allow-drop="allowDrop" @node-drop="nodeDrop">
        <span slot-scope="{ node, data }" class="custom-tree-node">
          <span>
            <!-- <i :class="node.icon" /> -->
            <!-- {{ node }} -->
            <img :src="data.icon" style="width: 16px; height: 16px; padding-top: 3px" />
            <!--   <i
              class="tree_icon"
              :style='{"background-image":"url("+data.icon+")"}'
            /> -->
            <!--   <i class="el-icon-edit"></i> -->
            {{ data.name }}
          </span>
        </span>
      </el-tree>
    </div>
    <div class="menus">
      <Menu ref="context_menu" :duration="1000" @itemClick="tree_menuItemClick">
        <!-- <MenuItem :disabled="!'root,project,folder,server,logicalGroup,deviceGroup,device,onlineChart'.includes(
          selectedNodeType
        )
          " text="展开" iconCls="icon-spread">
        </MenuItem>
        <MenuItem :disabled="!'root,project,folder,server,logicalGroup,deviceGroup,device,onlineChart'.includes(
          selectedNodeType
        )
          " text="折叠" iconCls="icon-fold">
        </MenuItem> -->
        <!--  <MenuItem
          :disabled="
            !'subDevice'.includes(
              selectedNodeType
            )
          "
          text="刷新"
          iconCls="icon-reflash"
        >
        <div
          align="right"
          style="font-size: 12px"
        >F5</div>
        </MenuItem> -->
        <!-- <MenuItem
          :disabled="
            !'subDevice'.includes(
              selectedNodeType
            )
          "
          text="刷新"
          iconCls="icon-reflash"
        >
        <div
          align="right"
          style="font-size: 12px"
        >F5</div>
        </MenuItem> -->
        <!--<Menu-sep />-->
        <!-- <MenuItem
        :disabled="!('root,project,folder,server,logicalGroup,deviceGroup,device,subDevice,onlineChart').includes(selectedNodeType)"
        text="打开"
        iconCls="icon-open"
      >
      <div
        align="right"
        style="font-size: 12px"
      >Ctrl+O</div>
        </MenuItem>-->
        <!--<MenuItem
        :disabled="!('root,project,folder,server,logicalGroup,deviceGroup,device,subDevice,onlineChart').includes(selectedNodeType)"
        text="新窗口中打开"
        iconCls="icon-new-open"
      >
      <div
        align="right"
        style="font-size: 12px"
      >Ctrl+Shift+O</div>
        </MenuItem>-->
        <!--<MenuItem
        :disabled="!('root,project,server,folder,logicalGroup,deviceGroup,device,subDevice,onlineChart').includes(selectedNodeType)"
        text="搜索"
        iconCls="icon-search"
      >-->
        <!--<div
        align="right"
        style="font-size: 12px"
      >Ctrl+F</div>
        </MenuItem>-->
        <Menu-sep v-if="!'subDevice' === selectedNodeType" />
        <MenuItem v-if="'root'.includes(selectedNodeType)" text="新建" iconCls="icon-new-add">
        <SubMenu menu-width="60px">
          <!--   <MenuItem text="文件链接" iconCls="icon-folder">
          </MenuItem> -->
          <MenuItem text="项目组" iconCls="icon-xm">
          </MenuItem>
        </SubMenu>
        </MenuItem>
        <MenuItem v-if="'project'.includes(selectedNodeType)" text="新建" iconCls="icon-new-add">
        <SubMenu menu-width="60px">
          <!--  <MenuItem text="文件链接" iconCls="icon-folder">
          </MenuItem> -->
          <MenuItem text="项目" iconCls="icon-server">
          </MenuItem>
          <MenuItem text="对象" iconCls="icon-object">
          <SubMenu menu-width="60px">
            <!--<MenuItem text="报警控制" iconCls="icon-alarm"></MenuItem>
                <MenuItem text="图形化界面" iconCls="icon-graphic"></MenuItem>
                <MenuItem text="时间表" iconCls="icon-chartTime"></MenuItem>-->

            <MenuItem text="用户" iconCls="icon-user" @click="user()">
            </MenuItem>
            <MenuItem text="用户组" iconCls="icon-userGroup" @click="userGroup()">
            </MenuItem>
            <MenuItem text="用户组-报警" iconCls="icon-userGroupAlarm" @click="alarmGroup()">
            </MenuItem>
            <MenuItem text="计算模块" iconCls="icon4">
            </MenuItem>
            <!-- <MenuItem text="趋势日志" iconCls="icon-trendLog">
            </MenuItem> -->
            <MenuItem text="曲线图-趋势" iconCls="icon-onlineChartLog">
            </MenuItem>
            <!--  <MenuItem text="能耗-批量统计" iconCls="icon-zzn">
            </MenuItem> -->
            <MenuItem text="柱状图-能耗" iconCls="icon-zzt">
            </MenuItem>
            <MenuItem text="统计模块" iconCls="icon14">
            </MenuItem>
            <!-- <MenuItem
                  text="视窗-报警"
                  iconCls="icon-alarm-window"
                ></MenuItem>
                <MenuItem
                  text="视窗-事件"
                  iconCls="icon-event-window"
                ></MenuItem> -->
          </SubMenu>
          </MenuItem>
        </SubMenu>
        </MenuItem>
        <MenuItem v-if="'folder'.includes(selectedNodeType)" text="新建" iconCls="icon-new-add">
        <SubMenu menu-width="60px">
          <!--     <MenuItem text="文件链接" iconCls="icon-folder">
          </MenuItem> -->
          <MenuItem text="对象" iconCls="icon-object">
          <SubMenu menu-width="60px">
            <MenuItem text="报警接收者-Printer" iconCls="icon1">
            </MenuItem>
            <MenuItem text="自定义报警对象4" iconCls="icon-changeState">
            </MenuItem>
            <MenuItem text="曲线图-实时" iconCls="icon-onlineChart">
            </MenuItem>
            <MenuItem text="曲线图-趋势" iconCls="icon-onlineChartLog">
            </MenuItem>
            <!--  <MenuItem
              text="图形化界面"
              iconCls="icon-graphic"
            >
            </MenuItem> -->
            <MenuItem text="假期计划表" iconCls="icon2">
            </MenuItem>
            <!--  <MenuItem
              text="记事本"
              iconCls="icon-noteBook"
            >
            </MenuItem> -->
            <MenuItem text="对象传输" iconCls="icon3">
            </MenuItem>
            <!-- <MenuItem
              text="时间表-批量"
              iconCls="icon-chartTime"
            >
            </MenuItem> -->
            <!--  <MenuItem
                  text="时间事件-对象"
                  iconCls="icon-chartTimeEventObj"
                ></MenuItem>
                <MenuItem
                  text="时间事件-列表"
                  iconCls="icon-chartTimeEventList"
                ></MenuItem>
                <MenuItem 49544c4447
                  text="趋势日志-计算"
                  iconCls="icon-trendLogCal"
                ></MenuItem>
                <MenuItem
                  text="趋势日志-导出"
                  iconCls="icon-trendLogOut"
                ></MenuItem> -->
            <MenuItem text="趋势日志" iconCls="icon-trendLog">
            </MenuItem>
            <MenuItem text="值-二进制" iconCls="icon6">
            </MenuItem>
            <MenuItem text="值-模拟量" iconCls="icon7">
            </MenuItem>
            <MenuItem text="值-计算" iconCls="icon8">
            </MenuItem>
            <!--  <MenuItem
              text="值-多态"
              iconCls="icon-Multistate"
            >
            </MenuItem> -->
            <MenuItem text="值-字符串" iconCls="icon-String">
            </MenuItem>
            <MenuItem text="计算模块" iconCls="icon-Count">
            </MenuItem>
            <!-- <MenuItem
                  text="报警视窗"
                  iconCls="icon-alarm-window"
                ></MenuItem> -->
          </SubMenu>
          </MenuItem>
        </SubMenu>
        </MenuItem>
        <MenuItem v-if="'server'.includes(selectedNodeType)" text="新建" iconCls="icon-new-add">
        <SubMenu menu-width="60px">
          <MenuItem text="逻辑组" iconCls="icon-logic-group">
          </MenuItem>
          <MenuItem text="对象" iconCls="icon-object">
          <SubMenu menu-width="60px">
            <MenuItem text="报警接收者-Printer" iconCls="icon1">
            </MenuItem>
            <!--  <MenuItem text="自定义报警对象3" iconCls="icon-changeState">
            </MenuItem> -->
            <!--   <MenuItem text="曲线图-实时" iconCls="icon-onlineChart">
            </MenuItem>
            <MenuItem text="曲线图-趋势记录" iconCls="icon-onlineChartLog">
            </MenuItem> -->
            <!--  <MenuItem text="图形化界面" iconCls="icon-graphic">
            </MenuItem> -->
            <MenuItem text="数据接口" iconCls="icon5">
            </MenuItem>
            <MenuItem text="假期计划表" iconCls="icon2">
            </MenuItem>
            <MenuItem text="时间表-批量" iconCls="icon-time1">
            </MenuItem>
            <MenuItem text="计算模块" iconCls="icon4">
            </MenuItem>
            <MenuItem text="值-模拟量" iconCls="icon7">
            </MenuItem>
            <MenuItem text="值-计算" iconCls="icon8">
            </MenuItem>
            <MenuItem text="能耗计算" iconCls="icon12">
            </MenuItem>
            <MenuItem text="能耗-批量统计" iconCls="icon13">
            </MenuItem>
            <MenuItem text="柱状图-能耗" iconCls="icon-zzt">
            </MenuItem>
            <MenuItem text="趋势日志" iconCls="icon-trendLog">
            </MenuItem>
            <MenuItem text="曲线图-趋势" iconCls="icon-onlineChartLog">
            </MenuItem>
            <MenuItem text="统计模块" iconCls="icon14">
            </MenuItem>
            <!-- <MenuItem text="盘管检查" iconCls="icon-pgjc">
            </MenuItem> -->
            <!--    <MenuItem
              text="记事本"
              iconCls="icon-noteBook"
            >
            </MenuItem> -->
            <!--  <MenuItem
              text="对象传输"
              iconCls="icon-objectTransfer"
            >
            </MenuItem> -->
            <!--  <MenuItem
              text="时间表"
              iconCls="icon-chartTime"
            >
            </MenuItem> -->
            <!-- <MenuItem
                  text="时间事件-对象"
                  iconCls="icon-chartTimeEventObj"
                ></MenuItem>
                <MenuItem
                  text="时间事件-列表"
                  iconCls="icon-chartTimeEventList"
                ></MenuItem>
                <MenuItem
                  text="趋势日志-计算"
                  iconCls="icon-trendLogCal"
                ></MenuItem>
                <MenuItem
                  text="趋势日志-导出"
                  iconCls="icon-trendLogOut"
                ></MenuItem> -->
            <!-- <MenuItem text="趋势日志" iconCls="icon-trendLog"></MenuItem>
                <MenuItem text="值-模拟量" iconCls="icon-Analog"></MenuItem>
                <MenuItem text="值-二进制" iconCls="icon-Binary"></MenuItem>
                <MenuItem text="值-多态" iconCls="icon-Multistate"></MenuItem>
                <MenuItem text="值-字符串" iconCls="icon-String"></MenuItem>
                <MenuItem text="数值计算" iconCls="icon-Count"></MenuItem>-->
            <!-- <MenuItem
                  text="报警视窗"
                  iconCls="icon-alarm-window"
                ></MenuItem> -->
          </SubMenu>
          </MenuItem>
        </SubMenu>
        </MenuItem>
        <MenuItem v-if="'logicalGroup'.includes(selectedNodeType)" text="新建" iconCls="icon-new-add">
        <SubMenu menu-width="60px">
          <!--  <MenuItem text="文件链接" iconCls="icon-folder">
          </MenuItem> -->
          <MenuItem text="逻辑组" iconCls="icon-logic-group">
          </MenuItem>
          <MenuItem text="设备组" iconCls="icon-device-group">
          <SubMenu menu-width="60px">
            <MenuItem text="IOT设备组" iconCls="icon-device-group">
            </MenuItem>
            <MenuItem text="OPC Server" iconCls="icon-device">
            </MenuItem>
            <MenuItem text="BACNET" iconCls="icon-save">
            </MenuItem>
          </SubMenu>
          </MenuItem>
          <MenuItem text="对象" iconCls="icon-object">
          <SubMenu menu-width="60px">
            <MenuItem text="报警接收者-Printer" iconCls="icon1">
            </MenuItem>
            <!--   <MenuItem text="自定义报警对象2" iconCls="icon-changeState">
            </MenuItem> -->
            <!--  <MenuItem text="曲线图-实时" iconCls="icon-onlineChart">
            </MenuItem>
            <MenuItem text="曲线图-趋势" iconCls="icon-onlineChartLog">
            </MenuItem> -->
            <MenuItem text="时间表-批量" iconCls="icon-time1">
            </MenuItem>
            <MenuItem text="数据接口" iconCls="icon5">
            </MenuItem>
            <MenuItem text="值-模拟量" iconCls="icon7">
            </MenuItem>
            <MenuItem text="值-计算" iconCls="icon8">
            </MenuItem>
            <MenuItem text="趋势日志" iconCls="icon-trendLog">
            </MenuItem>
            <MenuItem text="曲线图-趋势" iconCls="icon-onlineChartLog">
            </MenuItem>
            <MenuItem text="计算模块" iconCls="icon4">
            </MenuItem>
            <MenuItem text="能耗计算" iconCls="icon12">
            </MenuItem>
            <MenuItem text="能耗-批量统计" iconCls="icon13">
            </MenuItem>
            <MenuItem text="柱状图-能耗" iconCls="icon-zzt">
            </MenuItem>
            <MenuItem text="统计模块" iconCls="icon14">
            </MenuItem>
            <!--     <MenuItem text="图形化界面" iconCls="icon-graphic">
            </MenuItem> -->
            <!--  <MenuItem
                  text="假期计划表"
                  iconCls="icon-holidayPlan"
                ></MenuItem> -->
            <!--   <MenuItem
              text="记事本"
              iconCls="icon-noteBook"
            >
            </MenuItem> -->
            <!-- <MenuItem
                  text="对象传输"
                  iconCls="icon-objectTransfer"
                ></MenuItem> -->
            <!--  <MenuItem
              text="时间表"
              iconCls="icon-chartTime"
            >
            </MenuItem> -->
            <!-- <MenuItem
                  text="时间事件-对象"
                  iconCls="icon-chartTimeEventObj"
                ></MenuItem>
                <MenuItem
                  text="时间事件-列表"
                  iconCls="icon-chartTimeEventList"
                ></MenuItem>
                <MenuItem
                  text="趋势日志-计算"
                  iconCls="icon-trendLogCal"
                ></MenuItem>
                <MenuItem
                  text="趋势日志-导出"
                  iconCls="icon-trendLogOut"
                ></MenuItem> -->
            <!--<MenuItem text="趋势日志" iconCls="icon-trendLog"></MenuItem>
                <MenuItem text="值-模拟量" iconCls="icon-Analog"></MenuItem>
                <MenuItem text="值-二进制" iconCls="icon-Binary"></MenuItem>
                <MenuItem text="值-多态" iconCls="icon-Multistate"></MenuItem>
                <MenuItem text="值-字符串" iconCls="icon-String"></MenuItem>
                <MenuItem text="数值计算" iconCls="icon-Count"></MenuItem>-->
            <!--  <MenuItem
                  text="报警视窗"
                  iconCls="icon-alarm-window"
                ></MenuItem> -->
          </SubMenu>
          </MenuItem>
        </SubMenu>
        </MenuItem>
        <MenuItem v-if="'deviceGroup' === selectedNodeType" text="新建" iconCls="icon-new-add">
        <SubMenu menu-width="60px">
          <!-- <MenuItem text="文件链接" iconCls="icon-folder">
          </MenuItem> -->
          <MenuItem text="ICU" iconCls="icon-device">
          <!--  <SubMenu menu-width="60px">
            <MenuItem
              text="ICU"
              iconCls="icon-folder"
            >
            </MenuItem>
          </SubMenu> -->
          </MenuItem>
          <MenuItem text="海康摄像头" iconCls="icon-hkvideo">
          </MenuItem>
          <MenuItem text="对象" iconCls="icon-object">
          <SubMenu menu-width="60px">
            <MenuItem text="报警接收者-Printer" iconCls="icon1">
            </MenuItem>
            <!-- <MenuItem
              text="自定义报警对象"
              iconCls="icon-changeState"
            >
            </MenuItem> -->
            <MenuItem text="曲线图-实时" iconCls="icon-onlineChart">
            </MenuItem>
            <MenuItem text="曲线图-趋势" iconCls="icon-onlineChartLog">
            </MenuItem>
            <!-- <MenuItem
              text="曲线图-趋势记录"
              iconCls="icon-onlineChartLog"
            >
            </MenuItem> -->
            <!--     <MenuItem text="图形化界面" iconCls="icon-graphic">
            </MenuItem> -->
            <MenuItem text="假期计划表" iconCls="icon2">
            </MenuItem>
            <!-- <MenuItem
              text="记事本"
              iconCls="icon-noteBook"
            >
            </MenuItem> -->
            <MenuItem text="对象传输" iconCls="icon3">
            </MenuItem>
            <MenuItem text="时间表" iconCls="icon-time2">
            </MenuItem>
            <MenuItem text="时间表-批量" iconCls="icon-time1">
            </MenuItem>
            <MenuItem text="值-时间表" iconCls="icon-time3">
            </MenuItem>

            <MenuItem text="计算模块" iconCls="icon4">
            </MenuItem>
            <MenuItem text="值-二进制" iconCls="icon6">
            </MenuItem>
            <MenuItem text="值-模拟量" iconCls="icon7">
            </MenuItem>
            <MenuItem text="值-计算" iconCls="icon8">
            </MenuItem>
            <MenuItem text="数据接口" iconCls="icon5">
            </MenuItem>
            <MenuItem text="能耗计算" iconCls="icon12">
            </MenuItem>
            <MenuItem text="能耗-批量统计" iconCls="icon13">
            </MenuItem>
            <MenuItem text="柱状图-能耗" iconCls="icon-zzt">
            </MenuItem>
            <MenuItem text="创建规则" iconCls="icon-Multistate">
            </MenuItem>
            <MenuItem text="统计模块" iconCls="icon14">
            </MenuItem>
            <!-- <MenuItem text="值-多态" iconCls="icon-Multistate"></MenuItem>
                <MenuItem text="值-字符串" iconCls="icon-String"></MenuItem> -->
            <!-- <MenuItem
                  text="时间事件-对象"
                  iconCls="icon-chartTimeEventObj"
                ></MenuItem>
                <MenuItem
                  text="时间事件-列表"
                  iconCls="icon-chartTimeEventList"
                ></MenuItem>
                <MenuItem
                  text="趋势日志-计算"
                  iconCls="icon-trendLogCal"
                ></MenuItem>
                <MenuItem
                  text="趋势日志-导出"
                  iconCls="icon-trendLogOut"
                ></MenuItem> -->
            <!-- <MenuItem text="趋势日志" iconCls="icon-trendLog"></MenuItem>
                <MenuItem text="值-模拟量" iconCls="icon-Analog"></MenuItem>
                <MenuItem text="值-二进制" iconCls="icon-Binary"></MenuItem>
                <MenuItem text="值-多态" iconCls="icon-Multistate"></MenuItem>
                <MenuItem text="值-字符串" iconCls="icon-String"></MenuItem>
                <MenuItem text="数值计算" iconCls="icon-Count"></MenuItem>-->
            <!-- <MenuItem
                  text="报警视窗"
                  iconCls="icon-alarm-window"
                ></MenuItem> -->
          </SubMenu>
          </MenuItem>
        </SubMenu>
        </MenuItem>
        <MenuItem v-if="'device' === selectedNodeType" text="新建" iconCls="icon-new-add">
        <SubMenu menu-width="60px">
          <!-- <MenuItem text="文件链接" iconCls="icon-folder">
          </MenuItem> -->
          <MenuItem text="对象" iconCls="icon-object">
          <SubMenu menu-width="60px">
            <!--<MenuItem
                  text="报警接收者-Printer"
                  iconCls="icon-printer"
                ></MenuItem>-->
            <MenuItem text="自定义报警对象" iconCls="icon-changeState">
            </MenuItem>
            <MenuItem text="曲线图-实时" iconCls="icon-onlineChart">
            </MenuItem>
            <MenuItem text="曲线图-趋势" iconCls="icon-onlineChartLog">
            </MenuItem>
            <MenuItem text="创建方波" iconCls="icon-square">
            </MenuItem>
            <MenuItem text="能耗-批量统计" iconCls="icon13">
            </MenuItem>
            <MenuItem text="柱状图-能耗" iconCls="icon-zzt">
            </MenuItem>
            <!-- <MenuItem text="图形化界面" iconCls="icon-graphic"></MenuItem>-->
            <!--<MenuItem
            text="假期计划表"
            iconCls="icon-holidayPlan"
          ></MenuItem>-->
            <!--   <MenuItem
              text="记事本"
              iconCls="icon-noteBook"
            >
            </MenuItem> -->
            <!-- <MenuItem
                  text="对象传输"
                  iconCls="icon-objectTransfer"
                ></MenuItem>-->
            <!-- <MenuItem text="时间表" iconCls="icon-chartTime">
            </MenuItem> -->
            <!-- <MenuItem
                  text="时间事件-对象"
                  iconCls="icon-chartTimeEventObj"
                ></MenuItem>
                <MenuItem
                  text="时间事件-列表"
                  iconCls="icon-chartTimeEventList"
                ></MenuItem>
                <MenuItem
                  text="趋势日志-计算"
                  iconCls="icon-trendLogCal"
                ></MenuItem>
                <MenuItem
                  text="趋势日志-导出"
                  iconCls="icon-trendLogOut"
                ></MenuItem> -->
            <MenuItem text="趋势日志" iconCls="icon-trendLog">
            </MenuItem>
            <MenuItem text="能耗计算" iconCls="icon12">
            </MenuItem>
            <MenuItem text="值-二进制" iconCls="icon6">
            </MenuItem>
            <MenuItem text="值-模拟量" iconCls="icon7">
            </MenuItem>
            <MenuItem text="值-计算" iconCls="icon8">
            </MenuItem>
            <!--   <MenuItem
              text="值-多态"
              iconCls="icon-Multistate"
            >
            </MenuItem> -->
            <!--  <MenuItem
              text="值-字符串"
              iconCls="icon-String"
            >
            </MenuItem> -->
            <MenuItem text="计算模块" iconCls="icon4">
            </MenuItem>
            <!-- <MenuItem
                  text="报警视窗"
                  iconCls="icon-alarm-window"
                ></MenuItem> -->
            <MenuItem text="数据接口" iconCls="icon5">
            </MenuItem>
            <MenuItem text="环境健康指数" iconCls="icon-eviromentScore">
            </MenuItem>
            <!--  <MenuItem
              text="图库形化界面"
              iconCls="icon-graphic"
            >
            </MenuItem> -->
          </SubMenu>
          </MenuItem>
        </SubMenu>
        </MenuItem>
        <Menu-sep />
        <!--  <Menu-sep v-if="!'subDevice'===selectedNodeType" />-->
        <!--  <MenuItem
          v-if="'device' === selectedNodeType"
          text="程序下载"
          iconCls="icon-print"
        >
        </MenuItem> -->
        <Menu-sep v-if="!'subDevice' === selectedNodeType" />
        <MenuItem v-if="'device' === selectedNodeType" text="请求远程协助" iconCls="icon-event-window">
        </MenuItem>
        <MenuItem v-if="'project' === selectedNodeType" text="离线设备" iconCls="icon-device-off">
        </MenuItem>
        <MenuItem v-if="'project' === selectedNodeType" text="查询报告" iconCls="icon-trendLog-new">
        </MenuItem>
        <Menu-sep v-if="!'subDevice' === selectedNodeType" />
        <MenuItem v-if="'device' === selectedNodeType" text="断开远程协助" iconCls="icon-event-window">
        </MenuItem>
        <MenuItem text="批量处理" iconCls="icon-event-window">
        </MenuItem>
        <!--<Menu-sep v-if="'device'===selectedNodeType" />-->
        <MenuItem :disabled="!'root,project,folder,server,logicalGroup,deviceGroup,device,onlineChart'.includes(
          selectedNodeType
        )
          " text="刷新" iconCls="icon-reflash">
        <div align="right" style="font-size: 12px">F5</div>
        </MenuItem>
        <Menu-sep />
        <!-- <MenuItem
          :disabled="!'folder'.includes(selectedNodeType)"
          text="程序配置"
          iconCls="icon-event-window"
        >
        </MenuItem> -->
        <MenuItem v-if="'server' === selectedNodeType" text="服务器数据" iconCls="icon-event-window">
        </MenuItem>
        <Menu-sep v-if="'server' === selectedNodeType" />
        <MenuItem :disabled="!'project,folder,server,logicalGroup,deviceGroup,device,subDevice,onlineChart,formulaToValue'.includes(
          selectedNodeType
        )
          " text="授权" iconCls="icon-auth">
        </MenuItem>
        <Menu-sep />
        <!-- <MenuItem :disabled="!'project,folder,server,logicalGroup,deviceGroup,onlineChart,formulaToValue'.includes(
          selectedNodeType
        )
          " text="移入" iconCls="icon-cut">
        </MenuItem>
        <MenuItem :disabled="!'project,folder,server,logicalGroup,deviceGroup,onlineChart,formulaToValue'.includes(
          selectedNodeType
        )
          " text="移出" iconCls="icon-cut">
        </MenuItem> -->
        <MenuItem :disabled="!'subDevice'.includes(selectedNodeType)" text="复制" iconCls="icon-copy">
        </MenuItem>
        <MenuItem :disabled="!'subDevice'.includes(selectedNodeType)" text="粘贴" iconCls="icon-paste">
        </MenuItem>
        <!-- <Menu-sep /> -->
        <!-- <MenuItem
          :disabled="
            !'root,project,folder,server,logicalGroup,deviceGroup,device,onlineChart,graphic,formulaToValue，subDevice'.includes(
              selectedNodeType
            )
          "
          text="修改"
          iconCls="icon-rename"
        >
        </MenuItem> -->
        <MenuItem :disabled="!'project,folder,server,logicalGroup,deviceGroup,device,onlineChart,graphic,trendLog,trendChart,formulaToValue,histogram'.includes(
          selectedNodeType
        )
          " text="删除" iconCls="icon-delete">
        </MenuItem>
        <Menu-sep />
        <!--  <MenuItem text="链接" iconCls="icon-fileLink">
        </MenuItem> -->
        <MenuItem :text="currentNodeType == 'project' ? 'Logbook' : '备忘录'" iconCls="icon-noteBook">
        </MenuItem>
        <MenuItem :disabled="!'root,project,folder,server,logicalGroup,deviceGroup,device,onlineChart,subDevice,formulaToValue,trendChart,histogram'.includes(
          selectedNodeType
        )
          " text="属性" iconCls="icon-property">
        </MenuItem>

        <!-- <MenuItem
          :disabled="
            !'project,folder,server,logicalGroup,deviceGroup,device,onlineChart,subDevice,formulaToValue'.includes(
              selectedNodeType
            )
          "
          text="数据接口"
          iconCls="icon-property"
        ></MenuItem> -->
      </Menu>
    </div>
    <gs-modal v-model="visible" :before-close="beforeClose" class="my-test-class" title="删除" @close="close"
      @confirm="handleConfirm">
      <span>是否删除？</span>
    </gs-modal>
    <gs-modal v-model="visibleRoot" :before-close="beforeClose" class="my-test-class" title="删除" @close="close"
      @confirm="handleConfirm">
      <span>是否删除？</span>
    </gs-modal>
    <gs-modal v-model="updateTemp" :before-close="beforeCloseUpdateTemp" class="my-test-class" title="上传更新文件"
      @close="close" @confirm="handleConfirmUpdateTemp">
      <input type="file" id="uploadPic" />
    </gs-modal>
    <gs-modal v-model="batchShow" :before-close="batchShowClose" class="my-test-class" title="批量处理" @close="close"
      @confirm="batchShowOk">
      <span>点位名称：</span>
      <gs-input v-model="batchdata.name" placeholder="" size="mini"></gs-input>
      <span style="margin-top: 25px">点位值：</span>
      <gs-input v-model="batchdata.value" placeholder="" size="mini"></gs-input>
    </gs-modal>
    <!-- 备忘录弹窗 -->
    <!-- <div class="memoran">
      <el-dialog :close-on-click-modal='false' :visible.sync="memorandumShow" :before-close="memorandumShowClose"
        :title="nodeMomeName + '-备忘录'" width="50%" top="80px">
        <div class="textLine">
          <el-input v-model='memoText' type="textarea" :autosize="{ minRows: 36, maxRows: 34 }" placeholder=""
            size="mini"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <div class="memo-btn">
            <el-button type="primary" @click="memorandumShowOk" size="mini">保 存</el-button>
            <el-button @click="memorandumShow = false" size="mini">取 消</el-button>
          </div>
        </span>
      </el-dialog>
    </div> -->
    <div v-drag class="be-dialog" v-if="memorandumShow">
      <div class="be-dialog-header">
        <div class="be-dialog-richTextBody">
          <p>{{ nodeMomeName }}-备忘录</p>
        </div>
        <div>
          <i class="el-icon-check" style="cursor: pointer" @click="memorandumShowOk"></i>
          <i class="el-icon-close" style="cursor: pointer" @click="memorandumShow = false"></i>
        </div>
      </div>
      <div class="be-dialog-body">
        <Tinymce v-model="memoText" :height="687"></Tinymce>
      </div>
      <!-- <div class="be-dialog-btn">
        <div class="memo-btn">
          <el-button type="primary" @click="memorandumShowOk" size="mini">保 存</el-button>
          <el-button @click="memorandumShow = false" size="mini">取 消</el-button>
        </div>
      </div> -->
    </div>

    <gs-modal v-model="serviceShow" :before-close="serviceShowClose" class="my-test-class" title="服务器数据"
      @close="serviceShowClose" @confirm="serviceShowClose">
      <el-row>
        <el-col :span="12">
          <div>服务器名称：localhost.localdomain</div>
        </el-col>
        <el-col :span="12">
          <div>服务器Ip：127.0.0.1</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div>核心数：64</div>
        </el-col>
        <el-col :span="12">
          <div>操作系统：Linux</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div>CPU总的使用率：{{ serviceData.cpuzsyl }}%</div>
        </el-col>
        <el-col :span="12">
          <div>CPU系统使用率：{{ serviceData.cupxtsyl }}%</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div>CPU用户使用率：{{ serviceData.cupyhsyl }}%</div>
        </el-col>
        <el-col :span="12">
          <div>CPU当前等待率：{{ serviceData.cpudd }}%</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div>CPU当前空闲率：{{ serviceData.cpukx }}%</div>
        </el-col>
        <el-col :span="12">
          <div>CPU当前温度：{{ serviceData.cpuwd }}℃</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div>内存总量：250.22G</div>
        </el-col>
        <el-col :span="12">
          <div>已用内存：222.75G</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div>剩余内存：27.44G</div>
        </el-col>
        <el-col :span="12">
          <div>JVM占用的内存总数：2013.00M</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div>JVM最大可用内存总数：2013.00M</div>
        </el-col>
        <el-col :span="12">
          <div>JVM占用的内存总数：2013.00M</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div>JVM空闲内存：1665.02M</div>
        </el-col>
        <el-col :span="12">
          <div>JVM使用率：{{ serviceData.jvmsyl }}%</div>
        </el-col>
      </el-row>
    </gs-modal>
    <offLineTable ref="offLine"></offLineTable>
    <reportList ref="reportlist"></reportList>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
// import fuzzySearch from '../../../static/fuzzysearch.js'
import service from "../../service/leftService.js";
import online from "../../../static/img/new-icno/设备.png";
import offline from "../../../static/img/new-icno/设备（离线）1.png";
import offLineTable from "../deviceList/offLineDevice.vue";
import reportList from "../deviceList/reportList.vue";
import Tinymce from "../Tinymce/index.vue";
export default {
  components: {
    offLineTable,
    reportList,
    Tinymce,
  },
  data() {
    return {
      serviceData: {
        cpuzsyl: "15.2",
        cupxtsyl: "1.2",
        cupyhsyl: "14.22",
        cpudd: "0.03",
        cpuwd: "52",
        jvmsyl: "16.19",
        cpukx: "15.7",
      },
      nodeMomeName: "",
      serviceShow: false,
      batchdata: {
        name: "",
        value: "",
      },
      memorandumShow: false,
      batchShow: false,
      updateTemp: false,
      moveToId: "",
      shearMainId: "",
      visibleRoot: false,
      ...mapState(["nodeTreeArray"]),
      statusSubDevice: true,
      copyId: "",
      stickId: "",
      dialogVisible: false,
      values: "", // 计算后的值
      loading: true,
      node: {},
      currentNodeType: "",
      visible: false, // 控制删除界面的显示
      tree_width: 200, // 左侧树宽度
      grid_width: `${document.documentElement.clientWidth - 205}`, // 右侧列表宽度
      middle_height: `${(document.documentElement.clientHeight - 65) * 0.65}`, // 中间区域高度
      bottom_height: `${(document.documentElement.clientHeight - 65) * 0.35 - 2
        }`, // 底部区域高度
      grid_title: "文件夹",
      tree_collapsed: false,
      alarm_collapsed: false,
      tree_data: null,
      grid_data: null,
      alarm_data: null,
      event_data: null,
      selectedNodeType: "root",
      selectedNode: null,
      props: {
        label: "name",
      },
      deviceStatusList: [],
      timer: null,
      online,
      offline,
      facility: [],
      nideIdMome: "",
      rightNodeId: "",
      rightNodeName: "",
      memoText: "",
      md5: "",
      timerservice: null,
    };
  },
  computed: {
    ...mapState({
      nodeData: "nodeTree",
      addTreeNode: "addTreeNode",
      updateTreeNode: "updateTreeNode",
      delTreeNode: "delTreeNode",
      loginStatus: "loginStatus",
      // searchSelect: 'searchSelect'
    }),
    treeNodeDataWeb() {
      return this.$store.state.nodeTreeArray;
    },
  },
  watch: {
    loginStatus() {
      if (!this.loginStatus) {
        clearInterval(this.timer);
      }
    },
    "$store.state": {
      handler() {
        if (this.$store.state.isReloadTree === true) {
          this.getAllTree();
          this.donotNeedReload();
          console.log("reload Success!");
        }
      },
      deep: true,
    },
    addTreeNode() {
      this.treeAddNode();
    },
    updateTreeNode() {
      this.treeUpdateNode();
    },
    delTreeNode() {
      this.$refs.tree.remove(this.delTreeNode);
    },
    tree_data() { },
    nodeData() {
      //includes检测数组中是否包含这些
      if (
        "root,project,folder,server,logicalGroup,deviceGroup,device,subDevice,onlineChart".includes(
          this.nodeData.type
        )
      ) {
        setTimeout(() => {
          this.expandNode(this.nodeData.parentId);
          this.$refs.tree.setCurrentNode(this.nodeData);
        }, 10);
      }
    },
    "$store.state.nodeTreeArray"(newval, olval) {
      this.webScoketData(newval);
    },
    "$store.state.sortTree"(newval, oldval) {
      try {
        // 参数验证
        if (!newval || !newval.id || !Array.isArray(newval.children)) {
          return;
        }
        // 检查树组件ref
        const treeRef = this.$refs.tree;
        if (!treeRef) {
          return;
        }
        // 获取当前节点
        const currentNode = treeRef.getNode(newval.id);
        if (!currentNode) {
          return;
        }
        // 验证当前节点是否有子节点
        if (!Array.isArray(currentNode.data.children)) {
          return;
        }
        const orderMap = newval.children.reduce((map, item, index) => {
          if (item && item.id) {
            map[item.id] = index;
          }
          return map;
        }, {});
        // 对子节点进行排序
        const sortedChildren = [...currentNode.data.children].sort((a, b) => {
          // 处理可能为 null 或 undefined 的节点
          if (!a || !b) return 0;
          const orderA = a.id in orderMap ? orderMap[a.id] : Infinity;
          const orderB = b.id in orderMap ? orderMap[b.id] : Infinity;
          return orderA - orderB;
        });
        treeRef.updateKeyChildren(newval.id, sortedChildren);
      } catch (error) {
        console.error("排序过程中发生错误:", error);
      }
    },
  },
  created() {
    this.getAllTree();
    this.updateDeviceStatus();
  },
  mounted() {
    this.initEditor();
  },
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.timerservice);
  },
  methods: {
    ...mapMutations({
      dialogShow: "DIALOG_SHOW",
      propertiesDialogShow: "PROPERTIES_DIALOG_SHOW",
      onlineChartDialogShow: "ONLINECHART_PROPERTIES_DIALOG_SHOW",
      onlineChartTrendShow: "ONLINECHART_PROPERTIES_TREND_SHOW",
      //图形化展示
      graphiCallyShow: "GRAPHI_CALLY_SHOW",
      //记事本
      noteBookShow: "NOTE_BOOK_SHOW",
      //数据接口
      dataInterfaceShow: "DATA_INTERFACE_SHOW",
      //计算工具
      countBookShow: "COUNT_BOOK_SHOW",
      //趋势日志
      trendJournalShow: "TREND_JOURNAL_SHOW",
      //趋势日志数据
      trendLogsShow: "TREND_LOGS_SHOW",
      trendJournalExpressShow: "TREND_JOURNAL_EXPRESS_SHOW",
      alarmChartDialogShow: "ALARMCHART_PROPERTIES_DIALOG_SHOW",
      authorityShow: "AUTHORITY_SHOW",
      createUserShow: "CREATE_USER_SHOW",
      createGroupShow: "CREATE_GROUP_SHOW",
      //属性
      deviceDialogShow: "DEVICE_DIALOG_SHOW",
      //程序的下载
      orderDialogShow: "ORDER_DIALOG_SHOW",
      deviceListDialogShow: "DEVICE_LIST_DIALOG_SHOW",
      stateChangeShow: "CHANGE_OF_STATE_SHOW",
      donotNeedReload: "DONOT_NEED_RELOAD_TREE",
      alarmControlShow: "ALARM_CONTROL_SHOW",
      alarmGroupShow: "GROUP_ALARM_SHOW",
      addFolderDialog: "FOLDER_SHOW",
      addFolderDesginDialog: "FOLDER_DESGIN_SHOW",
      timeChartShow: "TIME_CHART_SHOW", // 时间表
      timeChartBatchShow: "TIME_CHART_BATCH_SHOW", // 时间表批量
      timeChartValueShow: "TIME_CHART_VALUE_SHOW", // 值时间表
      energyDialogShow: "ENERGY_DIALOG_SHOW", // 能耗计算
      coilDialogShow: "COIL_DIALOG_SHOW", // 盘管检查
      energyBarShow: "ENERGY_BAR_SHOW", // 能耗计算
      holidayShow: "HOLIDAY_SHOW", // 假期计划表
      searchDialogShow: "SEARCH_DIALOG_SHOW",
      squareDialogShow: "SQUARE_DIALOG_SHOW", // 创建方波
      objectTransferShow: "OBJECT_TRANSFER_SHOW",
      timeEventObejctShow: "TIME_EVENT_OBJECT_SHOW",
      timeEventListShow: "TIME_EVENT_LIST_SHOW",
      energyStatisticsShow: "ENERGY_STATISTICS_SHOW", // 能耗计算
      ruleDialogShow: "RULE_DIALOG_SHOW",
      statisticsModuleShow: "STATISTICS_MODULE_SHOW",
      EHIShow: "EHI_SHOW",
      hkvideoShow: "HKVIDEO_SHOW",
      valueCalculationShow: "VALUE_CALCULATION_SHOW",
    }),
    ...mapActions({
      showPointValueDialog: "showPointValueDialog",
    }),
    // 初始化富文本编辑框
    initEditor() {
      if (this.editor === "") {
        setTimeout(() => {
          this.editor = new E(this.$refs.editor);
          this.editor.config.onchange = () => {
            // 编辑器内容变化时，触发 input 事件传递给父组件
            this.$emit("input", this.editor.txt.html());
          };
          // 配置菜单和其他设置
          this.editor.config.menus = [
            "head", // 标题
            "bold", // 粗体
            "italic", // 斜体
            "underline", // 下划线
            "image", // 图片
            "link", // 链接
            "list", // 列表
            "undo", // 撤销
            "redo", // 重做
          ];
          this.editor.config.zIndex = 1000;
          // 创建编辑器
          this.editor.create();
          // 设置初始内容
          if (this.content) {
            this.editor.txt.html(this.content);
          }
        }, 500);
      }
    },
    serviceShowOk() {
      this.serviceShow = true;
      this.timerservice = setInterval(() => {
        let a = Math.floor(20 + Math.random() * (90 - 20));
        let b = Math.floor(20 + Math.random() * (99 - 20));
        let c = Math.floor(20 + Math.random() * (90 - 20));
        let d = Math.floor(20 + Math.random() * (99 - 20));
        let e = Math.floor(20 + Math.random() * (90 - 20));
        let f = Math.floor(20 + Math.random() * (99 - 20));
        this.serviceData.cupxtsyl =
          Math.floor(0 + Math.random() * (3 - 0)) + "." + b;
        this.serviceData.cpuzsyl =
          Math.floor(10 + Math.random() * (20 - 10)) + "." + a;
        this.serviceData.cupkx =
          Math.floor(10 + Math.random() * (15 - 10)) + "." + e;
        this.serviceData.cupyhsyl =
          Math.floor(10 + Math.random() * (15 - 10)) + "." + c;
        this.serviceData.cpudd =
          Math.floor(0 + Math.random() * (3 - 0)) + "." + d;
        this.serviceData.jvmsyl =
          Math.floor(10 + Math.random() * (20 - 10)) + "." + f;
      }, 2000);
    },
    serviceShowClose() {
      this.serviceShow = false;
    },
    // 备忘录关闭
    memorandumShowClose() {
      this.memorandumShow = false;
    },
    // 获取备忘录最新数据
    getMemoData() {
      this.memoText = "";
      service
        .getMemo(this.rightNodeId)
        .then((res) => {
          console.log("res数据", res);
          this.md5 = res.md5;
          this.memoText = res.memo;
          this.memorandumShow = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 备忘录修改确定
    memorandumShowOk() {
      let date = new Date();
      let month = date.getMonth() + 1; //当前月
      let year = date.getFullYear(); //当前年(4位)
      let ri = date.getDate();
      let hou = date.getHours(); //获取当前小时数(0-23)
      let fen = date.getMinutes(); //获取当前分钟数(0-59)
      this.memoText =
        this.memoText +
        `  ---${localStorage.getItem(
          "username"
        )}  ${year}.${month}.${ri}  ${hou}:${fen}`;
      let obj = {
        id: this.nideIdMome,
        memo: this.memoText,
        md5: this.md5,
      };
      service
        .saveMemo(obj)
        .then((res) => {
          this.$Message.success("保存成功");
        })
        .catch((err) => {
          this.$Message.error(err.message);
        });
    },
    // 批量处理关
    batchShowClose() {
      this.batchShow = false;
    },
    // 批量处理确定
    batchShowOk() {
      service
        .groupControl(
          this.nodeData.id,
          this.batchdata.name,
          this.batchdata.value
        )
        .then((res) => {
          this.$Message.success("修改成功");
        })
        .catch((err) => { });
      this.batchShow = false;
    },
    // 断开ICU连接
    breakOffIcu() {
      service
        .deviceUnlinkIcu(this.nodeData)
        .then((res) => {
          this.$Message.success("与服务平台断开连接成功");
        })
        .catch((err) => {
          this.$Message.info(err.message);
        });
    },
    handleConfirmUpdateTemp() {
      /* service.deviceLink(this.nodeData).then(res => {
        this.$Message.success(res.message)
      }) */
      service
        .serviceLink(this.nodeData.attribute.sn)
        .then((res) => {
          this.$Message.success("连接到服务平台成功");
        })
        .catch((err) => {
          this.$Message.error(err.message);
        });
    },
    beforeCloseUpdateTemp() {
      this.updateTemp = false;
    },
    //renderContent节点
    expandNode(id) {
      if (id !== "0") {
        let node = this.$refs.tree.getNode(id);
        node.expanded = true;
        if (node.data.parentId !== "0") {
          this.expandNode(node.data.parentId);
        }
      }
    },
    getAllTree() {
      this.loading = true;
      service
        .getAllTree()
        .then((res) => {
          let username = localStorage.getItem("username");
          // this.tree_data = res[0];
          this.traverseTree(res[0]);
          // 对树形目录进行过滤操作
          let node = this.filterNode(res[0]);
          setTimeout(() => {
            this.tree_data = [node];
            this.loading = false;
          }, 1000);
        })
        .catch((err) => {
          this.$Message.error(err.message);
          this.loading = false;
        });
    },
    filterNode(node) {
      if (node == null) {
        console.log("node为空");
        return node;
      } else {
        if (node.children == null) {
        } else {
          for (let i = 0; i < node.children.length; i++) {
            if (node.children[i].type == "logicalGroup") {
              debugger
              node.children[i].children.forEach((item, index) => {
                if (
                  item.type == "deviceGroup" ||
                  item.type == "histogram" ||
                  item.type == "trendChart" ||
                  item.type == "logicalGroup"
                ) {
                } else {
                  node.children[i].children = node.children[i].children.filter(
                    (val) => val.type !== item.type
                  );
                }
              });
            }
            if (node.children[i].type == "server") {
              node.children[i].children.forEach((item, index) => {
                if (
                  item.type == "logicalGroup" ||
                  item.type == "histogram" ||
                  item.type == "trendChart"
                ) {
                } else {
                  node.children[i].children = node.children[i].children.filter(
                    (val) => val.type !== item.type
                  );
                }
              });
            }
            this.filterNode(node.children[i]);
          }
          return node;
        }
      }
    },
    /*renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
        <span title={node.label}>{node.label}</span>
        </span>);
    },*/
    getDeviceStatus() {
      service
        .getDeviceStatus()
        .then((res) => {
          this.deviceStatusList = res;
          this.deviceStatusList.forEach((res) => {
            let node = this.$refs.tree.getNode(res.id);
            if (node != null) {
              if (node.data.attribute.isOnline !== res.isOnline) {
                let temp = node.data.name;
                node.data.name = "";
                if (res.isOnline) {
                  node.data.icon = this.online;
                  node.data.attribute.isOnline = res.isOnline;
                  node.data.name = temp;
                } else {
                  node.data.icon = this.offline;
                  node.data.attribute.isOnline = res.isOnline;
                  node.data.name = temp;
                }
              }
            }
          });
        })
        .catch((err) => {
          console.log(err);
          //this.$Message.error(err.message)
          clearInterval(this.timer);
        });
    },
    // websocket接收的数据并进行挂载
    webScoketData() {
      this.deviceStatusList = this.$store.state.nodeTreeArray;
      this.deviceStatusList.forEach((res) => {
        let node = this.$refs.tree.getNode(res.id);
        if (node != null) {
          if (node.data.attribute.isOnline !== res.isOnline) {
            let temp = node.data.name;
            node.data.name = "";
            if (res.isOnline) {
              node.data.icon = this.online;
              node.data.attribute.isOnline = res.isOnline;
              node.data.name = temp;
            } else {
              node.data.icon = this.offline;
              node.data.attribute.isOnline = res.isOnline;
              node.data.name = temp;
            }
          }
        }
      });
    },
    updateDeviceStatus() {
      clearInterval(this.timer);
      this.getDeviceStatus();
    },
    traverseNode(node) {
      if (node.type === "device") {
        this.statusSubDevice = node.attribute.isOnline;
      }
      switch (node.type) {
        case "project":
          node["icon"] = "../../../static/img/aim-icon/new-xm.png";
          break;
        case "folder":
          node["icon"] = "../../../static/img/new-icno/文件夹.png";
          break;
        case "deviceGroup":
          node["icon"] = "../../../static/img/aim-icon/new-sbzs.png";
          break;
        case "device":
          // node['icon'] = '../../../static/img/new-icno/设备.png'
          if (node.attribute.isOnline) {
            node["icon"] = "../../../static/img/aim-icon/icuon.png";
          } else {
            node["icon"] = "../../../static/img/aim-icon/icuoff.png";
          }
          break;
        case "HIKSCamera":
          node["icon"] = "../../../static/img/aim-icon/视频.png";
          break;
        case "onlineChart":
          //node['icon'] = '../../../static/img/new-icno/实时动态图.png'
          node["icon"] = "../../../static/img/aim-icon/new-sh.png";
          break;
        case "trendChart":
          //node['icon'] = '../../../static/img/new-icno/实时动态图.png'
          node["icon"] = "../../../static/img/aim-icon/new-qxt.png";
          break;
        // 加载图形化界面图标
        case "graphic":
          node["icon"] = "../../../static/img/aim-icon/new-txhjm.png";
          break;
        // 趋势日志
        case "trendLog":
          node["icon"] = "../../../static/img/aim-icon/趋势日志.png";
          break;
        case "subDevice":
          let len = node.name.length;
          let str = node.name.substring(len - 3, len);
          if (str == "CMD") {
            node["icon"] = "../../../static/img/aim-icon/new-ml.png";
          } else {
            if (
              node.attribute.isOnline === false ||
              this.statusSubDevice === false
            ) {
              node["icon"] = "../../../static/img/aim-icon/new-lxl.png";
            } else {
              node["icon"] = "../../../static/img/aim-icon/new-cl.png";
            }
          }
          break;
        case "server":
          node["icon"] = "../../../static/img/aim-icon/new-fwq.png";
          break;
        case "histogram":
          node["icon"] = "../../../static/img/aim-icon/zhuzhuangtu.png";
          break;
        case "root":
          //node['icon'] = '../../../static/img/new-icno/平台new.png'
          node["icon"] = "../../../static/img/aim-icon/new-yun.png";
          break;
        case "logicalGroup":
          node["icon"] = "../../../static/img/aim-icon/new-ljz.png";
          break;
        case "formulaToValue":
          node["icon"] = "../../../static/img/aim-icon/计算器.png";
          break;
        case "FANCheck":
          node["icon"] = "../../../static/img/aim-icon/jiancha.png";
          break;
        case "ValueCheck":
          node["icon"] = "../../../static/img/aim-icon/jiancha.png";
          break;
        default:
          break;
      }
      return node;
    },
    traverseTree(node) {
      if (!node) {
        return;
      }
      let stack = [];
      stack.push(node);
      let tmpNode;
      while (stack.length > 0) {
        tmpNode = stack.pop();
        this.traverseNode(tmpNode);
        if (tmpNode.children && tmpNode.children.length > 0) {
          let i = tmpNode.children.length - 1;
          for (i = tmpNode.children.length - 1; i >= 0; i--) {
            stack.push(tmpNode.children[i]);
          }
        }
      }
    },
    //Tree点击鼠标左键触发
    tree_left_click(node, type) {
      let _this = this;
      // this.tree_data = null
      if (!this.memorandumShow) {
        this.nideIdMome = node.id;
      }
      if (node.type == "logicalGroup") {
        if (node.children.length == 0) {
          this.treeAddNode();
        }
      }
      /* if (node.type === "project") {
        //this.getAllTree()
        service
          .getTree("", this.selectedNode.id)
          .then((res) => {
            _this.$store.state.addTreeNode = res;
          })
          .catch((err) => {
            console.log(err);
          });
      } */
      if (node.type === "formulaToValue") {
        service
          .formulaToValue(node.id)
          .then((res) => {
            _this.values = res.value;
            _this.dialogVisible = true;
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if (this.$refs.tree.store.nodesMap[node.id].expanded) {
        this.$refs.tree.store.nodesMap[node.id].expanded = false;
        node.unfold = false;
      } else {
        this.$refs.tree.store.nodesMap[node.id].expanded = true;
        node.unfold = true;
        if (node.type === "device" || node.type === "deviceGroup") {
          let nodeId = node.id;
          this.treeAddNode();
          /* service.getChildrenNode(nodeId).then((res) => {
            _this.$store.state.addTreeNode = res;
            setTimeout(function () {
              _this.loading = false;
            }, 1500);
          })
            .catch((err) => {
              console.info(err);
              setTimeout(function () {
                _this.loading = false;
              }, 1000);
            }); */
        }
      }
      this.$store.state.leftClickNode = new Date().getTime();
      this.$store.state.nodeTree = node;
      this.$store.state.objectInfo = node;
      this.selectedNode = node;
      this.selectedNodeType = node.type;
      // if (this.selectedNodeType === 'onlineChart') {
      //   this.$router.push({name: 'onlineChart', query: {id: node.id}})
      // } else {
      if (this.selectedNodeType === "graphic") {
        let modelId = node.attribute.modelId;
        let id = node.parentId;
        let parentId = node.parentId;
        if (modelId == "116") {
          this.$router.push({
            name: "tencentView",
            query: {
              facility: this.facility,
              id: node.parentId,
              t: Date.now(),
            },
          });
        } else {
          this.$router.push({
            name: "graphiCallyShow",
            query: {
              facility: this.facility,
              id: node.parentId,
              t: Date.now(),
            },
          });
        }
      } else {
        if (node.type === "root") {
          this.$router.push({ name: "Home" });
        } else {
          this.$router.push({
            name: "List",
            query: { id: node.id, type: this.selectedNodeType },
          });
        }
      }
      if (type === 1) {
        this.$refs.tree.getNode(node.id).expanded = true;
      }
      // }
    },
    //Tree点击鼠标右键出发
    tree_right_click(event, node, value, element) {
      this.rightNodeId = node.id;
      this.rightNodeName = node.name;
      if (!this.memorandumShow) {
        this.nideIdMome = node.id;
        this.nodeMomeName = node.name;
      }
      // 拿到对象的所有属性
      this.node = node;
      this.currentNodeType = node.type;
      // 右键后向vuex中存储数据
      this.$store.state.objectInfo = node;
      this.$store.state.nodeTree = node;
      this.selectedNodeType = node.type;
      this.$refs.tree.setCurrentNode(node);
      this.selectedNode = node;
      this.$refs.context_menu.showContextMenu(event.pageX, event.pageY);
      // 模板添加的操作把必要的值存入localStorage中
      if (node.type === "device") {
        let deviceId = node.id;
        let subDeviceId = "";
        if (node.children) {
          for (let i = 0; i < node.children.length; i++) {
            if (node.children[i].type === "subDevice") {
              subDeviceId += node.children[i].id + ",";
            }
          }
        }
        localStorage.setItem("deviceId" + node.id, deviceId);
        localStorage.setItem("subDeviceId" + node.id, subDeviceId);
      }
      /*  this.$store.state.leftClickNode = new Date().getTime();
       this.$store.state.nodeTree = node;
       this.selectedNode = node;
       this.selectedNodeType = node.type; */
    },
    tree_selection_change(node) {
      this.selectedNode = node;
      this.selectedNodeType = node.type;
    },
    tree_menuItemClick(event) {
      switch (event) {
        case "展开":
          this.openTree();
          break;
        case "折叠":
          this.fold();
          break;
        case "删除":
          this.visible = true;
          break;
        case "项目组":
          this.addFolder("project");
          break;
        case "文件夹":
          this.addFolder("folder");
          break;
        case "项目":
          this.addFolder("server");
          break;
        case "逻辑组":
          this.addFolder("logicalGroup");
          break;
        case "IOT设备组":
          this.addFolder("deviceGroup");
          break;
        case "ICU":
          this.deviceListDialogShow();
          break;
        case "报警控制":
          this.alarmControl();
          break;
        case "时间表":
          this.timeChart();
          break;
        case "时间表-批量":
          this.timeChartBatchShow();
          break;
        case "值-时间表":
          this.timeChartValueShow();
          break;
        case "假期计划表":
          this.holidayChart();
          break;
        case "用户":
          this.user();
          break;
        case "用户组":
          this.userGroup();
          break;
        case "用户组-报警":
          this.alarmGroup();
          break;
        case "自定义报警对象":
          this.changeOfState();
          break;
        case "曲线图-实时":
          this.turnToChart();
          break;
        case "柱状图-能耗":
          this.energyBarShow();
          break;
        case "能耗-批量统计":
          this.energyStatisticsShow();
          break;
        case "创建方波":
          this.squareDialogShow();
          break;
        case "曲线图-趋势":
          this.turnToChartTrend();
          break;
        case "记事本":
          this.noteBook();
          break;
        case "计算模块":
          this.countBook();
          break;
        case "趋势日志":
          this.trendJournal();
          break;
        case "趋势日志-导出":
          this.trendJournalExpres();
          break;
        case "报警接收者-Printer":
          this.turnToAlarmChart();
          break;
        case "图形化界面":
          this.graphiCally();
          break;
        case "移入":
          this.shear();
          break;
        case "移出":
          this.moveTo();
          break;
        case "值-模拟量":
          this.showPointValueDialog({
            type: "Analog",
            isEdit: false,
          });
          break;
        case "值-计算":
          this.valueCalculationShow();
          break;
        case "值-二进制":
          this.showPointValueDialog({
            type: "Binary",
            isEdit: false,
          });
          break;
        case "值-多态":
          this.showPointValueDialog({
            type: "Multistate",
            isEdit: false,
          });
          break;
        case "值-字符串":
          this.showPointValueDialog({
            type: "String",
            isEdit: false,
          });
          break;
        case "授权":
          this.authorityShow();
          0;
          break;
        case "程序下载":
          this.orderDownShow();
          break;
        case "属性":
          this.properties();
          break;
        case "修改":
          this.properties();
          break;
        case "搜索":
          this.searchDialogShow();
          break;
        case "对象传输":
          this.objectTransferShow();
          break;
        case "时间事件-对象":
          this.timeEventObejctShow();
          break;
        case "时间事件-列表":
          this.timeEventListShow();
          break;
        case "刷新":
          this.renovate();
          break;
        case "检查设备":
          this.isOnline();
          break;
        case "复制":
          this.copyData();
          break;
        case "粘贴":
          this.stickData();
          break;
        case "数据接口":
          this.dataInterfaceShow();
          break;
        case "图形化界面":
          alert(1);
          break;
        case "请求远程协助":
          this.handleConfirmUpdateTemp();
          break;
        case "断开远程协助":
          this.breakOffIcu();
          break;
        case "批量处理":
          this.batchShow = true;
          break;
        case "备忘录":
        case "Logbook":
          this.nodeMomeName = this.rightNodeName;
          this.memorandumShow = false;
          this.getMemoData();
          break;
        case "服务器数据":
          this.serviceShowOk();
          break;
        case "能耗计算":
          this.energyDialogShow();
          break;
        case "盘管检查":
          this.coilDialogShow();
        case "离线设备":
          this.offLineData();
          break;
        case "查询报告":
          this.getReportData();
          break;

        case "统计模块":
          this.statisticsModuleShow();
          break;
        case "创建规则":
          this.ruleDialogShow();
        case "链接":
          this.getNewLink();
        case "环境健康指数":
          this.EHIShow();
          break;
        case "海康摄像头":
          this.hkvideoShow();
          break;
        default:
          break;
      }
    },
    // 链接跳转
    getNewLink() {
      service.getNode(this.nodeData.id).then((res) => {
        if (res.fileLink) {
          window.open(res.fileLink);
        } else if (res.fileLink == null || res.fileLink == "") {
          this.$message({
            message: "暂无链接",
            type: "warning",
          });
        }
      });
    },
    // 离线设备列表
    offLineData() {
      this.$refs.offLine.getShowData();
    },
    // 查询报告
    getReportData() {
      this.$refs.reportlist.getShowData();
    },
    kong() { },
    addFolder(type) {
      // 添加路径
      this.$store.state.type = type;
      this.addFolderDialog();
    },
    treeAddNode() {
      this.loading = true;
      let oldChildNodes = this.$refs.tree.getNode(
        this.selectedNode.id
      ).childNodes;
      /* let expandedNodes = [];
      this.addExpandedNodes(oldChildNodes, expandedNodes); */
      if (
        this.selectedNode.type === "device" ||
        this.selectedNode.type === "deviceGroup" ||
        this.selectedNode.type === "server" ||
        this.selectedNode.type === "project"
      ) {
        service
          .getChildrenNode(this.selectedNode.id)
          .then((res) => {
            setTimeout(() => {
              let updateNode = res[0];
              this.traverseTree(updateNode);
              this.$refs.tree.updateKeyChildren(
                this.selectedNode.id,
                updateNode.children
              );
              this.loading = false;
            }, 100);
            /*  expandedNodes.forEach((e) => {
               this.$refs.tree.store.nodesMap[e.data.id].expanded = true;
             }); */
            /*  this.$refs.tree.store.nodesMap[
               this.selectedNode.id
             ].expanded = true; */
            /*  setTimeout(() => {
               if (Array.isArray(this.addTreeNode)) {
                 this.$refs.tree.setCurrentNode(this.addTreeNode[0]);
               } else {
                 this.$refs.tree.setCurrentNode(this.addTreeNode);
               }
             }, 20); */
          })
          .catch((err) => {
            console.log(err);
            // this.$Message.error(err.message)
          });
      } else {
        service
          .getTree("", this.selectedNode.id)
          .then((res) => {
            // 进行过滤
            if (res[0].type == "logicalGroup") {
              res[0].children.forEach((item) => {
                if (
                  item.type == "deviceGroup" ||
                  item.type == "histogram" ||
                  item.type == "trendChart" ||
                  item.type == "logicalGroup"
                ) {
                } else {
                  res[0].children = res[0].children.filter(
                    (e) => e.type !== item.type
                  );
                }
              });
            }
            let updateNode = res[0];
            this.traverseTree(updateNode);
            this.$refs.tree.updateKeyChildren(
              this.selectedNode.id,
              updateNode.children
            );
            expandedNodes.forEach((e) => {
              this.$refs.tree.store.nodesMap[e.data.id].expanded = true;
            });
            this.$refs.tree.store.nodesMap[
              this.selectedNode.id
            ].expanded = true;
            setTimeout(() => {
              if (Array.isArray(this.addTreeNode)) {
                this.$refs.tree.setCurrentNode(this.addTreeNode[0]);
              } else {
                this.$refs.tree.setCurrentNode(this.addTreeNode);
              }
            }, 20);
          })
          .catch((err) => {
            console.log(err);
            // this.$Message.error(err.message)
          });
        this.loading = false;
      }
    },
    addExpandedNodes(childNodes, expandedNodes) {
      if (childNodes.length > 0) {
        childNodes.forEach((res) => {
          this.addExpandedNodes(res.childNodes, expandedNodes);
          if (res.expanded) {
            expandedNodes.push(res);
          }
        });
      }
    },
    // treeAddNode () {
    //   let newChild = null
    //   if (Array.isArray(this.addTreeNode)) {
    //     let array = this.addTreeNode
    //     array.forEach(e => {
    //       e = this.traverseTree(e)
    //     })
    //     newChild = array
    //   } else {
    //     newChild = this.traverseNode(this.addTreeNode)
    //   }
    //   if (newChild.length) {
    //     newChild.forEach(res => {
    //       this.$refs.tree.append(res, this.selectedNode)
    //     })
    //   } else {
    //     this.$refs.tree.append(newChild, this.selectedNode)
    //   }
    //   this.$refs.tree.store.nodesMap[this.selectedNode.id].expanded = true
    //   this.$refs.tree.setCurrentNode(newChild)
    // },
    treeUpdateNode() {
      let node = this.$refs.tree.getNode(this.updateTreeNode.id);
      if (this.updateTreeNode.type === "onlineChart") {
        node.data.name = this.updateTreeNode.name;
        node.data.description = this.updateTreeNode.description;
        node.data.attribute = this.updateTreeNode.attribute;
        //node.data = this.updateTreeNode;
        //node.data.icon = "../../../static/img/aim-icon/曲线图.png";
      } else {
        node.data.name = this.updateTreeNode.name;
        node.data.fullName = this.updateTreeNode.fullName;
        node.data.description = this.updateTreeNode.description;
      }
    },
    treeDeleteNode() {
      // 删除节点
      service
        .removePoint(this.selectedNode.id)
        .then((res) => {
          this.$Message.success("删除成功");
          this.$refs.tree.remove(this.selectedNode);
          // this.$store.state.nodeTree = {}
          // this.$router.push({ name: "Home" });
        })
        .catch((err) => {
          console.log(err);
          // this.$Message.error(err.message)
        });
    },
    orderDownShow() {
      //程序的下载
      //弹出框的展示
      // this.orderDialogShow()
      this.$router.push({
        name: "orderSelectAll",
        query: { id: this.$store.state.objectInfo.id, type: "order" },
      });
    },
    // 刷新操作
    renovate() {
      let _this = this;
      //this.getAllTree()
      /* service.getChildrenNode(this.selectedNode.id).then(res => {

      }) */
      this.loading = true;
      if (
        this.selectedNode.type == "project" ||
        this.selectedNode.type == "root" ||
        this.selectedNode.type == "server"
      ) {
        this.getAllTree();
        setTimeout(() => {
          this.$message({
            message: "刷新成功",
            type: "success",
            duration: 1000,
          });
          _this.loading = false;
        }, 1000);
      } else {
        service
          .getTree("", this.selectedNode.id)
          .then((res) => {
            if (this.selectedNode.type == "logicalGroup") {
              res[0].children.forEach((item, index) => {
                if (
                  item.type == "deviceGroup" ||
                  item.type == "histogram" ||
                  item.type == "trendChart" ||
                  item.type == "logicalGroup"
                ) {
                } else {
                  res[0].children = res[0].children.filter(
                    (val) => val.type !== item.type
                  );
                }
              });
              _this.$store.state.addTreeNode = res;
              _this.loading = false;
            } else {
              _this.$store.state.addTreeNode = res;
              _this.loading = false;
            }

            /* let node = this.$refs.tree.getNode(this.selectedNode.id)
            node.loaded = false
            node.expand() */
            /* this.$notify({
              message: '刷新成功',
              type: 'success',
              offset: 25
            }); */
            //this.$Message.success("刷新成功")
            this.$message({
              message: "刷新成功",
              type: "success",
              duration: 1000,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }

      /*setTimeout(function () {
        _this.loading = false
      },2000)*/
      //this.webScoketData();
    },
    // 移动
    shear() {
      this.shearMainId = this.nodeData.id;
    },
    // 移动到
    moveTo() {
      this.moveToId = this.nodeData.id;
      let obj = {
        fromId: this.shearMainId,
        toId: this.moveToId,
      };
      service
        .getMove(obj)
        .then((res) => {
          this.$Message.success("移动成功！");
        })
        .catch((err) => {
          this.$Message.error(err);
        });
    },
    properties() {
      // 属性
      if (
        this.selectedNodeType === "project" ||
        this.selectedNodeType === "server" ||
        this.selectedNodeType === "folder" ||
        this.selectedNodeType === "logicalGroup" ||
        this.selectedNodeType === "deviceGroup"
      ) {
        this.propertiesDialogShow();
      }
      if (this.selectedNodeType === "root") {
        this.propertiesDialogShow();
      }
      if (this.selectedNodeType === "onlineChart") {
        this.onlineChartDialogShow();
      }
      if (this.selectedNodeType === "alarmReceiverEmail") {
        this.alarmChartDialogShow();
      }
      if (this.selectedNodeType === "device") {
        // 弹出框的展示
        this.deviceDialogShow();
      }
      if (this.selectedNodeType === "subDevice") {
        // 弹出框的展示
        this.deviceDialogShow();
        // this.$Message.error('子设备无属性设置')
      }
      if (this.selectedNodeType === "graphic") {
        this.graphiCallyShow();
      }
      if (this.selectedNodeType === "trendChart") {
        this.onlineChartTrendShow();
      }
      if (this.selectedNodeType === "histogram") {
        this.energyBarShow();
      }
      this.hideRightMenu();
    },
    //曲线图-实时
    turnToChart() {
      this.onlineChartDialogShow();
      this.hideRightMenu();
    },
    //曲线图-趋势记录
    turnToChartTrend() {
      this.onlineChartTrendShow();
      this.hideRightMenu();
    },
    //图形化界面
    graphiCally() {
      this.graphiCallyShow();
      this.hideRightMenu();
    },
    //记事本
    noteBook() {
      this.noteBookShow();
      this.hideRightMenu();
    },
    //计算工具
    countBook() {
      this.countBookShow();
      this.hideRightMenu();
    },
    //趋势日志
    trendJournal() {
      this.trendJournalShow();
      this.hideRightMenu();
    },
    //趋势日志导出
    trendJournalExpres() {
      this.trendJournalExpressShow();
      this.hideRightMenu();
    },
    turnToAlarmChart() {
      this.alarmChartDialogShow();
      this.hideRightMenu();
    },
    user() {
      this.createUserShow();
      this.hideRightMenu();
    },
    userGroup() {
      this.createGroupShow();
      this.hideRightMenu();
    },
    addNewDevice() {
      // this.deviceDialogShow()
      this.deviceListDialogShow();
      this.hideRightMenu();
    },
    changeOfState() {
      this.stateChangeShow();
      this.hideRightMenu();
    },
    alarmControl() {
      this.alarmControlShow();
      this.hideRightMenu();
    },
    alarmGroup() {
      this.alarmGroupShow();
      this.hideRightMenu();
    },
    close() {
      this.visible = false;
    },
    beforeClose() {
      this.visible = false;
    },
    handleConfirm() {
      this.treeDeleteNode();
      this.visible = false;
    },
    hideRightMenu() {
      //传输正确的数据(已标签的形式)
      let rMenu = $("#rMenu");
      let secondMenu = $(".second-menu");
      let thirdMenu = $(".third-menu");
      rMenu.css({ visibility: "hidden" });
      secondMenu.css({ visibility: "hidden" });
      thirdMenu.css({ visibility: "hidden" });
    },
    timeChart() {
      // 时间表
      this.timeChartShow();
      this.hideRightMenu();
    },
    holidayChart() {
      // 假期计划表
      this.holidayShow();
      this.hideRightMenu();
    },
    // 展开
    openTree() {
      let _this = this;
      this.$refs.tree.store.nodesMap[this.node.id].expanded = true;
      this.node.unfold = true;
      service
        .getTree("", this.node.id)
        .then((res) => {
          _this.$store.state.addTreeNode = res;
        })
        .catch((err) => {
          console.info(err);
        });
    },
    // 折叠
    fold() {
      this.$refs.tree.store.nodesMap[this.node.id].expanded = false;
      this.node.unfold = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 检查设备是否在线
    isOnline() {
      service
        .isOnline(this.nodeData.id)
        .then((res) => {
          this.$Message.success("设备检查成功");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 复制
    copyData() {
      this.copyId = this.nodeData.id;
      if (this.copyId === "") {
        this.$Message.error("复制失败");
      } else {
        this.$Message.success("复制成功");
      }
    },
    // 粘贴
    stickData() {
      this.stickId = this.nodeData.id;
      service
        .copyPaste(this.copyId, this.stickId)
        .then((res) => {
          this.$Message.success("粘贴成功");
        })
        .catch((err) => {
          this.$Message.error("粘贴失败");
        });
    },
    allowDrag(node) {
      // if (node.data.type === 'device' && !node.data.attribute.isOnline) {
      return true;
      // }
    },
    allowDrop(draggingNode, dropNode, type) {
      if (
        draggingNode.data.parentId === dropNode.data.parentId &&
        (type === "prev" || type === "next")
      ) {
        return true;
      }
    },
    nodeDrop(draggingNode, dropNode, type, e) {
      // console.log(draggingNode);
      // console.log(dropNode);
      // console.log(type);
      const parentNode = this.$refs.tree.getNode(draggingNode.data.parentId);
      // console.log(this.$refs.tree.getNode(draggingNode.data.parentId));
      const list = [];
      parentNode.data.children.forEach((item) => {
        list.push(item.id);
      });
      service
        .sort(list)
        .then((res) => {
          this.tree_left_click(parentNode.data, 1);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style>
.menus>>>.menu {
  background-color: #525659 !important;
  color: #bdbdbd !important;
  border: 2px solid #6d7174 !important;
  box-shadow: 2px 2px 3px #6d7174 !important;
}

.menus>>>.menu-shadow {
  box-shadow: 2px 2px 3px #6d7174 !important;
}

.menus>>>.menu-sep {
  border-bottom: 1px solid #4b4f52 !important;
}

.menus>>>.menu-line {
  border-right: 1px solid #4b4f52 !important;
}

.menus>>>.menu-active {
  background-color: #8a8a8a !important;
}

.menu {
  background-color: #525659 !important;
  color: #bdbdbd !important;
  border: 2px solid #6d7174 !important;
  box-shadow: 2px 2px 3px #6d7174 !important;
}

.menu-shadow {
  box-shadow: 2px 2px 3px #6d7174 !important;
}

.menu-sep {
  border-bottom: 1px solid #4b4f52 !important;
}

.menu-line {
  border-right: 1px solid #4b4f52 !important;
}

.menu-active {
  background-color: #8a8a8a !important;
}
</style>
<style scoped>
.be-dialog {
  position: absolute;
  z-index: 999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1300px;
  height: 750px;
  backdrop-filter: blur(7.5px);
  -webkit-backdrop-filter: blur(7.5px);
  border: 1px solid #404040;
  border-radius: 5px 0 0 0;
  background-color: #777575;
  overflow: hidden;
}

.be-dialog-header {
  width: 100%;
  height: 30px;
  padding: 0px 10px 0 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #f7f7f7;
  font-size: 13px;
  border-bottom: 1px solid #404040;
  background-color: #5a5e61;
}

.be-dialog-richTextBody {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .el-button {
    margin-left: 10px;
  }
}

.be-dialog-body {
  width: 100%;
  height: 333px;
  padding: 0.5px;
  background-color: #777575;
}

.be-dialog-btn {
  width: 100%;
  height: 36px;
  padding-right: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.el-icon-close {
  margin-left: 10px;
}

.memoran>>>.el-dialog {
  background: #e8e6d2 !important;
  border-radius: 4px !important;
}

.memoran>>>.el-dialog__header {
  padding: 10px 20px 0px 8px !important;
  background-color: #e8e6d2 !important;
}

.memoran>>>.el-dialog__title {
  color: rgb(74, 72, 72);
  font-size: 13px;
  background-color: transparent !important;
}

.memoran>>>.el-dialog__headerbtn {
  top: 10px;
}

.memoran>>>.el-dialog__body {
  padding: 0px 8px 8px 8px !important;
  background-color: #e8e6d2 !important;
}

.memoran>>>.el-dialog__footer {
  padding: 0px 8px 8px 0px;
}

.memo-btn>>>.el-button {
  font-size: 10px !important;
  color: rgb(171, 171, 171) !important;
}

.textLine>>>.el-textarea__inner {
  color: rgb(216, 216, 216) !important;
  border: 1px solid transparent !important;
  font-size: 11px !important;
}

.el-back-tree>>>.el-tree {
  color: #dbdbdd;
  background: rgba(0, 0, 0, 0);
}

.el-back-tree>>>.el-checkbox__inner {
  background: rgba(0, 0, 0, 0);
}

.el-back-tree>>>.el-tree-node__content:hover {
  background: rgba(104, 147, 215, 0.4);
}

.el-back-tree>>>.el-tree-node:focus>.el-tree-node__content {
  background-color: rgba(0, 0, 0, 0);
}

.el-back-tree>>>.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/left-side/sideTree.vue